<template>
	<div class="holiday-alert-wrap">
		<el-alert class="holiday-alert" type="warning" show-icon>
			<p slot="title" class="holiday-alert-title">
				工单服务国庆中秋假期放假安排：<br />
国庆中秋假期将至，2020年10月1日至10月8日期间，讯飞开放平台将继续为您提供服务支持。节假日期间，您可以通过拨打客服电话：4000199199（8:30～22:00，全年无休）与我们联络，其他渠道的服务将于10月9日起恢复正常。给您带来的不便敬请谅解，感谢您的支持！
讯飞开放平台全体工作人员祝您国庆中秋双节快乐！
			</p>
		</el-alert>
	</div>
</template>
<script>
export default {
  name: 'NationalDayAlert',
}
</script>
<style>
	.el-alert__icon {
		line-height: 23px;
	}
	.el-alert__icon.is-big {
		display: table-cell;
	}
	.el-alert__content {
    vertical-align: middle;
	}
</style>

<style scoped>
	.holiday-alert-wrap .el-alert--warning.is-light {
		border-radius: 0px;
		padding: 5px 16px;
		border-bottom: solid 1px #f5e3bf;
		align-items: flex-start;
	}
	.holiday-alert-wrap .el-alert--warning.is-light .holiday-alert-title {
		color: #f93;
		line-height: 1.8;
	}
	a {
		color: #409EFF;
	}
</style>




// WEBPACK FOOTER //
// app/components/HolidayAlert/NationalDay.vue